import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useLoader } from '../../_helper/LoaderContext';
import { peymentDoctor } from './service/doctor-service';
import { toast } from 'react-toastify';
import { useLab } from '../../_helper/PharmacyProvider';

export default function DoctorPayment({ show, onHide, doctor, getList }) {

    const [amount, setAmount] = useState();
    const [note, setNote] = useState("");
    const [errors, setErrors] = useState({});
    const { setLoading } = useLoader();
    const { currentLab } = useLab()

    // console.log(doctor)
    useEffect(() => {
        setAmount(doctor.commissionAmount?.toFixed(2))
    },[doctor])

    const handleSubmit = async () => {
        const newErrors = {};
        if (!amount || Number(amount) <= 0) {
            newErrors.amount = "Amount is required and must be greater than 0.";
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return

        setLoading(true)
        try {
            const form_data = new FormData();
            form_data.append("doctorId",doctor._id);
            form_data.append("amount",parseFloat(amount));
            form_data.append("currencyType",currentLab?.baseCurrency);
            form_data.append("notes",note);
            const res = await peymentDoctor(form_data)
            if (res.data.success == true) {
                toast.success(res.data.message);
                getList();
                onHide();
                setAmount("");
                setNote("");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    };

    return (
        <Modal show={show} onHide={onHide} scrollable centered>
            <Modal.Header closeButton>
                <Modal.Title>Payment</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>

                    {/* Amount */}
                    <Form.Group className="mb-3">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            isInvalid={!!errors.amount}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.amount}
                        </Form.Control.Feedback>
                    </Form.Group>

                    {/* Note */}
                    <Form.Group>
                        <Form.Label>Note</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Write note (optional)"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        />
                    </Form.Group>

                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="primary" onClick={handleSubmit}>
                    Pay
                </Button>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
